import { render } from "./DeptContent.vue?vue&type=template&id=867b3fde"
import script from "./DeptContent.vue?vue&type=script&lang=js"
export * from "./DeptContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__